/* eslint-disable import/prefer-default-export */
/**
 * Whitelabel Config Selectors
 * Memoized selectors for accessing whitelabel configuration data
 */

/**
 * Select the entire whitelabel configuration from Redux state.
 * @param {object} state - Redux state.
 * @returns {object} Whitelabel configuration object.
 */
export const selectWhitelabelConfig = (state) => {
  return state.whitelabelConfig || {};
};

/**
 * Select API configuration from whitelabel config state
 * Returns the entire API configuration object
 *
 * @param {Object} state - Redux state
 * @returns {Object} API configuration with purchaseUrl, searchUrl, mobileKey, desktopKey, etc.
 */
export const selectWhitelabelApi = (state) => {
  return state.whitelabelConfig?.env?.api || {};
};

/**
 * Select entire whitelabel environment configuration
 *
 * @param {Object} state - Redux state
 * @returns {Object} Environment configuration
 */
export const selectWhitelabelEnvs = (state) => {
  return state.whitelabelConfig?.env || {};
};

/**
 * Select whitelabel features configuration
 *
 * @param {Object} state - Redux state
 * @returns {Object} Features configuration
 */
export const selectWhitelabelFeatures = (state) => {
  return state.whitelabelConfig?.features || {};
};

/**
 * Select whitelabel copies (translations/strings)
 *
 * @param {Object} state - Redux state
 * @returns {Object} Copies configuration
 */
export const selectWhitelabelCopies = (state) => {
  return state.whitelabelConfig?.copies || {};
};

/**
 * Select whitelabel theme configuration
 *
 * @param {Object} state - Redux state
 * @returns {Object} Theme configuration with icons, colors, styles, etc.
 */
export const selectWhitelabelTheme = (state) => {
  return state.whitelabelConfig?.env?.theme || {};
};
